<template>
  <div>
    <div
      v-if="unassigned || fullName"
      :title="unassigned ? 'Not Assigned' : fullName"
      class="avatar-initials"
      :style="{ 'backgroundColor': unassigned ? '#dddddd' : backgroundColour, 'height': `${this.size}px`, 'width': `${this.size}px` }">
      <span>{{ unassigned ? '' : initials }}</span>
    </div>
    <div v-else><!-- empty --></div>
  </div>
</template>

<script>

export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    fullName: {
      type: String,
      default: '',
    },
    unassigned: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    initials() {
      let initials = '';
      let full_name = this.fullName || '';
      if (full_name) {
        let parts = full_name.split(' ');
        let first = parts.slice(0, 1).shift();
        let last = parts.slice(1, 2).shift();
        first = first ? first.charAt(0) : '?';
        last = last ? last.charAt(0) : '';
        initials = first + last;
      }
      return initials;
    },
    backgroundColour() {
      // Adapted from https://codepen.io/felipepucinelli/pen/QyVJbM
      let initials = this.initials;
      const colours = ["#DC143C", "#008B8B", "#FF6347", "#9b59b6", '#1E90FF', '#4B0082'];
      let charIndex1 = initials.length >= 1 ? initials.charCodeAt(0) - 65 : 0;
      let charIndex2 = initials.length >= 2 ? initials.charCodeAt(1) - 65 : 0;
      let colourIndex = (charIndex1 + charIndex2) % colours.length;
      return colours[colourIndex];
    }
  },
};
</script>

<style scoped>
.avatar-initials {
  color: #fff;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarInitials.vue